<script lang="ts">
  import type ERAR from '$lib/erar/spec';
  import MatchSummary from './match-summary.svelte';
  import MatchDetails from './match-details.svelte';
  import { ChevronDown } from 'lucide-svelte';

  export let matches: ERAR.Schema.MatchParticipation[];

  const isDetailsOpen: boolean[] = [];
</script>

<ul>
  {#each matches as match, i (match.matchId)}
    <li class="match-item">
      <details bind:open={isDetailsOpen[i]}>
        <summary>
          <MatchSummary {match} />
          <!-- <ChevronDown /> -->
        </summary>
        {#if isDetailsOpen[i]}
          <MatchDetails {match} />
        {/if}
      </details>
    </li>
  {/each}
</ul>

<style lang="postcss">
  ul {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
  }

  .match-item {
    display: flex;
    flex-direction: column;
    flex: 1;
    border-radius: var(--radius-2);
    border: 1px solid var(--border-subtle);

    &:hover {
      background-color: var(--elevation-1);
    }

    details {
      display: flex;
    }

    summary {
      list-style: none;
      display: flex;
      flex: 1 0 auto;
      /* padding: var(--space-4) var(--space-5); */

      :global(.match-summary) {
        flex: 1 0 auto;
      }
    }
  }
</style>
